import { useGetDevelopmentDatabaseInfo } from '@/api/generated/ping/ping';

export function DevelopmentDatabaseBadge() {
  const { data, isLoading, isError } = useGetDevelopmentDatabaseInfo({
    query: {
      staleTime: Infinity,
      retry: false,
    },
  });

  if (isLoading || isError || data === undefined || isProductionEnvironment(data.environmentName)) {
    return null;
  }

  const label = data.databaseName
    ? `ENV: ${data.environmentName} | DB: ${data.databaseName}`
    : `ENV: ${data.environmentName}`;

  return (
    <span
      className="text-phx-text-muted text-phx-xs inline-flex min-w-28 justify-end font-medium tracking-wide"
      data-testid="main-menu-runtime-info"
      title={label}
    >
      {label}
    </span>
  );
}

function isProductionEnvironment(environmentName: string): boolean {
  return environmentName.localeCompare('Production', undefined, { sensitivity: 'accent' }) === 0;
}
